import { OnInit, Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../services/session-storage.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UtilityAppsService } from './utility-apps.service';
import { RightBridgeApiService } from '../../../app/services/right-bridge-api.service';

@Component({
  selector: 'app-utility-apps',
  templateUrl: './utility-apps.component.html',
  styleUrls: ['./utility-apps.component.scss'],
  imports: [MatButtonModule, MatIconModule, MatMenuModule],
})
export class UtilityAppsComponent implements OnInit {
  private ss = inject(SessionStorageService);
  private router = inject(Router);
  private uas = inject(UtilityAppsService);
  private rbs = inject(RightBridgeApiService);

  @Input() utilityApps;
  noPassUtilityApps;
  noPassShowLearnButton;
  rights = [];
  showLearnButton = false;

  constructor() {
    this.rights = this.ss.get('rights');
  }

  ngOnInit(): void {
    this.uas.appsList$.subscribe(val => {
      this.noPassUtilityApps = val;
    });

    this.rbs.getLandingPageGroup().subscribe(resp => {
      this.showLearnButton = resp.UnitLandingPage.LearnButtonShow;
    });
  }

  hasUtilityApps() {
    let hasAppsAndRights = false;
    this.noPassUtilityApps.map(app => {
      if (app.right && this.rights.includes(app.right)) {
        hasAppsAndRights = true;
      }
    });

    return this.showLearnButton || hasAppsAndRights;
  }

  goToPage(link: string): void {
    this.router.navigate([link]);
  }
}
